// removed by extract-text-webpack-plugin
module.exports = {"container":"_1aSym4k37m2vWfJG0HDAcP","icon":"WbNk3fzExsIIDD_Tq-jHt","title":"kdWts7KH2gPnx7PG7tghS"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Templates/Create/styles.css
// module id = 2965
// module chunks = 0